import React from 'react';

import { GroupConsumer } from '../../../contexts/GroupContext';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import AboutCard from '../AboutCard/AboutCard';
import GroupHomeLink from '../Elements/GroupHomeLink/GroupHomeLink';

import './AboutPage.scss';

export default class AboutPage extends React.PureComponent {
    constructor(props) {
        super();
    }

    render() {
        return (
            <div className="component-Groups-AboutPage">
                <CommonCardShell>
                    <GroupConsumer>
                        {({ group }) => (
                            <AboutCard
                                displayText={group ? group.aboutGroup : ''}
                                locationList={group.locations}
                            />
                        )}
                    </GroupConsumer>

                    <GroupHomeLink />
                </CommonCardShell>
            </div>
        );
    }
}
